// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractSimpleModuleUi, abstractSimpleModuleUiOptions } from '../_abstract/ui';
/**
 * Component capable of rendering the `BlockquoteModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let BlockquoteModuleUi = class BlockquoteModuleUi extends AbstractSimpleModuleUi {
};
BlockquoteModuleUi = __decorate([
    Component({ ...abstractSimpleModuleUiOptions, name: 'BlockquoteModuleUi' })
], BlockquoteModuleUi);
export { BlockquoteModuleUi };
